<template>
    <VueDragResize v-show="isAuthenticated && videoConferenceOngoing"
      :aspectRatio="false" :isActive="true" :stickSize="10"
      :w="width" :h="height" :x="left" :y="top"
      :isResizable="!minimized && !docked" :isDraggable="!minimized && !docked"
      v-on:resizestop="resize" v-on:dragstop="resize"
      style="z-index: 999;box-shadow: 5px 0 4px -4px rgba(0, 0, 0, 0.2), -5px 0 4px -4px rgba(0, 0, 0, 0.2);"
    >
    <v-card width="100%" height="100%" :elevation="(minimized || docked) ? 0 : 3" :loading="!hasJoined" style="height: 100%;width: 100%;">
      <v-app-bar id="app-bar" :elevation="minimized ? 0 : 3">
        <v-icon color="primary" style="margin-right: 10px;">mdi-video-account</v-icon>
        <v-toolbar-title>{{ activeRoom ? activeRoom.name : '' }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <div style="height: 100%;width: 190px;transform: scale(0.7);">
            <v-flex class="d-flex justify-center" style=";width: 100%;">
                <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                    <v-btn icon v-show="!minimized" @click="minimized=true" v-bind="attrs" v-on="on"><v-icon>mdi-window-minimize</v-icon></v-btn>
                    </template>
                    <span>{{$t('videoconf.tooltip.minimize')}}</span>
                </v-tooltip>

                <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                    <v-btn icon @click="dock()" v-bind="attrs" v-on="on"><v-icon>{{docked === true ? 'mdi-arrow-expand' : 'mdi-dock-window'}}</v-icon></v-btn>
                    </template>
                    <span>{{docked === true ? $t('videoconf.tooltip.expand') : $t('videoconf.tooltip.small')}}</span>
                </v-tooltip>

                <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                    <v-btn icon v-show="!fullscreen" @click="fullscreen=true" v-bind="attrs" v-on="on"><v-icon>mdi-arrow-expand-all</v-icon></v-btn>
                    </template>
                    <span>{{$t('videoconf.tooltip.fullscreen')}}</span>
                </v-tooltip>

                <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                    <v-btn icon @click="activeRoom.copyGuestUrl()" v-bind="attrs" v-on="on"><v-icon>mdi-content-copy</v-icon></v-btn>
                    </template>
                    <span>{{$t('videoconf.tooltip.copyGuestLink')}}</span>
                </v-tooltip>

                <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                    <v-btn icon @click="openInNewTab" v-bind="attrs" v-on="on"><v-icon>mdi-open-in-new</v-icon></v-btn>
                    </template>
                    <span>{{$t('videoconf.tooltip.openNew')}}</span>
                </v-tooltip>

                <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                    <v-btn icon @click="hangup" v-bind="attrs" v-on="on"><v-icon color="red">mdi-phone-hangup</v-icon></v-btn>
                    </template>
                    <span>{{$t('videoconf.tooltip.hangup')}}</span>
                </v-tooltip>
            </v-flex>
          </div>
      </v-app-bar>
      <div id="meetRoom" class="room-frame" frameborder="0" :width="width" :height="height" v-show="!minimized" allow="camera *;microphone *;display-capture *" style="height: 85%;width: 100%;padding-top:10px;"></div>
    </v-card>
    </VueDragResize>
</template>
<script>

import { mapActions, mapGetters } from 'vuex'
import VueDragResize from 'vue-drag-resize'
import events from 'Store/events'

export default {
  name: 'active-conference-overlay',
  components: { VueDragResize },
  mounted () {
    window.addEventListener('unload', (e) => { this.hangup() }, false)
    window.addEventListener('resize', (event) => {
      if (this.docked) {
        this.overlayDocked()
      } else if (this.minimized) {
        this.overlayMinimized()
      } else if (this.fullscreen) {
        this.overlayFullscreen()
      } else {
        this.overlayExpand()
      }
    }, true)
  },
  watch: {
    jitsi () {
      if (this.jitsi) {
        this.jitsi.addListener('videoConferenceJoined', () => {
          this.onJoin()
        })
        this.jitsi.addListener('readyToClose', () => {
          this.readyToClose()
        })
      }
    },
    minimized () { if (this.minimized) { this.overlayMinimized() } },
    docked () { if (this.docked) { this.overlayDocked() } },
    fullscreen () { if (this.fullscreen) { this.overlayFullscreen() } }
  },
  computed: {
    ...mapGetters({
      isAuthenticated: 'isAuthenticated',
      getLeft: 'videoConferenceOverlay/left',
      getTop: 'videoConferenceOverlay/top',
      getWidth: 'videoConferenceOverlay/width',
      getHeight: 'videoConferenceOverlay/height',
      getJitsi: 'videoConferenceOverlay/jitsi',
      activeRoom: 'videoconfer/activeRoom',
      getHasJoined: 'videoConferenceOverlay/hasJoined',
      getDocked: 'videoConferenceOverlay/docked',
      getMinimized: 'videoConferenceOverlay/minimized',
      getFullscreen: 'videoConferenceOverlay/fullscreen',
      currentUsername: 'settings/userName',
      userName: 'sipuaClidName'
    }),
    jitsi: { get () { return this.getJitsi }, set (jitsi) { this.setJitsi(jitsi) } },
    left: { get () { return this.getLeft }, set (left) { this.setLeft(left) } },
    top: { get () { return this.getTop }, set (top) { this.setTop(top) } },
    width: { get () { return this.getWidth }, set (width) { this.setWidth(width) } },
    height: { get () { return this.getHeight }, set (height) { this.setHeight(height) } },
    hasJoined: { get () { return this.getHasJoined }, set (hasJoined) { this.setHasJoined(hasJoined) } },
    docked: { get () { return this.getDocked }, set (docked) { this.setDocked(docked) } },
    minimized: { get () { return this.getMinimized }, set (minimized) { this.setMinimized(minimized) } },
    fullscreen: { get () { return this.getFullscreen }, set (fullscreen) { this.setFullscreen(fullscreen) } },
    videoConferenceOngoing: function () { return this.activeRoom !== null }
  },
  methods: {
    ...mapActions({
      setLeft: 'videoConferenceOverlay/setLeft',
      setTop: 'videoConferenceOverlay/setTop',
      setWidth: 'videoConferenceOverlay/setWidth',
      setHeight: 'videoConferenceOverlay/setHeight',
      setOverlay: 'videoConferenceOverlay/setOverlay',
      setJitsi: 'videoConferenceOverlay/setJitsi',
      destroyRoom: 'videoconfer/destroyActiveRoom',
      setHasJoined: 'videoConferenceOverlay/setHasJoined',
      setDocked: 'videoConferenceOverlay/setDocked',
      setMinimized: 'videoConferenceOverlay/setMinimized',
      setFullscreen: 'videoConferenceOverlay/setFullscreen'
    }),
    resize (overlay) {
      this.width = overlay.width
      this.height = overlay.height
      this.top = overlay.top
      this.left = overlay.left
    },
    overlayFullscreen () {
      if (this.hasJoined) { this.jitsi.executeCommand('setTileView', true) }
      const overlayConfig = {
        top: 0,
        left: 0,
        width: window.innerWidth,
        height: window.innerHeight
      }
      this.minimized = false
      this.docked = false
      this.fullscreen = true
      this.resizeOverlay(overlayConfig)
    },
    overlayExpand () {
      if (this.hasJoined) { this.jitsi.executeCommand('setTileView', true) }
      const screenWidth = window.innerWidth
      const screenHeight = window.innerHeight
      const overlayConfig = {
        top: 200,
        left: 600,
        height: (screenHeight - 600) > 300 ? screenHeight - 600 : 400,
        width: (screenWidth - 1000) > 300 ? screenWidth - 1000 : 300
      }
      this.minimized = false
      this.docked = false
      this.fullscreen = false
      this.resizeOverlay(overlayConfig)
    },
    overlayDocked () {
      if (this.hasJoined) { this.jitsi.executeCommand('setTileView', false) }
      const screenWidth = window.innerWidth
      const footerHeight = document.querySelector('footer')
      const overlayConfig = {
        top: footerHeight.offsetTop - 800,
        left: screenWidth - (420 + 66),
        width: 420,
        height: 800
      }
      this.minimized = false
      this.docked = true
      this.fullscreen = false
      this.resizeOverlay(overlayConfig)
    },
    overlayMinimized () {
      if (this.hasJoined) { this.jitsi.executeCommand('setTileView', false) }
      const screenWidth = window.innerWidth
      const footerHeight = document.querySelector('footer')
      const overHeader = document.querySelector('[id=app-bar]')
      const overlayConfig = {
        top: footerHeight.offsetTop - overHeader.clientHeight,
        left: screenWidth - (420 + 66),
        width: 420,
        height: 0
      }
      this.minimized = true
      this.docked = false
      this.fullscreen = false
      this.resizeOverlay(overlayConfig)
    },
    async resizeOverlay (config) {
      await this.setTop(config.top)
      await this.setLeft(config.left)
      await this.setWidth(config.width)
      await this.setHeight(config.height)
    },
    hangup () {
      if (this.jitsi) {
        this.jitsi.executeCommand('hangup')
      }
    },
    // event from jitsi when after hangup and is ready to close
    readyToClose () {
      this.hasJoined = false
      const parent = document.querySelector('[id=meetRoom]')
      parent.innerHTML = ''
      this.setJitsi(null)
      this.destroyRoom()
    },
    dock () {
      this.docked ? this.overlayExpand() : this.docked = !this.docked
    },
    openInNewTab () {
      const url = this.activeRoom?.getShortUrl(this.currentUsername)
      window.open(url, '_blank')
      this.dbg(`Open url in a new tab: ${url}`)
      this.hangup()
    },
    onJoin () {
      events.pubNotify({ text: 'videoconf.msg.joined', status: 'success' })
      this.jitsi.executeCommand('setTileView', false)
      this.hasJoined = true
    }
  }
}
</script>

<style scoped>
</style>
